// export function length_to_index(length) {
//     return Math.floor(length / 50);
// }
//
// export function index_to_length(index) {
//     return index * 50;
// }

export function getTemplateId(index, arrayBuffer) {
    return arrayBuffer[index * 9 + 0];
}

export function getTemplateWidth(index, arrayBuffer) {
    return arrayBuffer[index * 9 + 1];
}

export function getTemplateHeight(index, arrayBuffer) {
    return arrayBuffer[index * 9 + 2];
}

export function getTemplateProfileLength(index, arrayBuffer) {
    return arrayBuffer[index * 9 + 3];
}

export function getTemplateFrameArea(index, arrayBuffer) {
    const result = arrayBuffer[index * 9 + 4];
    return result;
}

export function getTemplateFrameCount(index, arrayBuffer) {
    return arrayBuffer[index * 9 + 5];
}

export function getTemplateCategoryId(index, arrayBuffer) {
    return arrayBuffer[index * 9 + 6];
}

export function getTemplateClusterId(index, arrayBuffer) {
    return arrayBuffer[index * 9 + 7];
}

// export function getTemplateSimilarId(index, arrayBuffer) {
//     return arrayBuffer[index * 9 + 8];
// }
